module.exports = __webpack_public_path__ + "static/media/carAccidents.372c333f.svg";